import React from 'react';
import { NoValue } from '@/Components/Primitives';

import { defaults, usePredefined, useServices } from '../../Data/Services';
import { classNames } from '../../Services/helpers';

const Services = ({ services: listedServices, ul, className }) => {
    const {services} = useServices();
    const {predefined} = usePredefined()

    if (!listedServices) {
        return <NoValue />
    }

    const getTitle = (service) => {
        const own = services?.find(s => s.type === service);

        return own?.title
            ?? predefinedTitle(predefined, service)
            ?? defaults.find(s => s.type === service)?.title
            ?? service;
    };

    const titled = listedServices.map(service => getTitle(service));

    if (ul) {
        return <ul className={classNames('list-unstyled mb-0', className)}>
            {titled.map((service, i) => <li key={service + i}>{getTitle(service)}</li>)}
        </ul>
    }

    return <span className={className}>{titled.join(', ')}</span>;
}

/**
 * The catalogue is grouped by category, so the title lives on the service inside
 * it — reading it off the category (which has none) returned undefined for every
 * type a business had not defined itself.
 */
const predefinedTitle = (categories, type) => {
    for (const category of categories ?? []) {
        const match = category.services?.find(s => s.type === type);

        if (match) {
            return match.title;
        }
    }

    return null;
};

const getServiceString = (serviceIds, services) => {
    if (!services || !serviceIds) {
        return '';
    }

    const titles = services.filter(s => serviceIds.includes(s.type)).map(s => s.title);

    return titles.join(', ');
}

export default Services;

export {
    getServiceString
}
